<template lang="pug">
  v-row(no-gutters justify="center")
    v-col(cols="12")
      v-simple-table( class="m-block-receipt-sale-mixed-payment-types mx-sm-10")
        template(v-slot:default)
          thead
            tr
              th(width="25")
              th(class="text-left" style="padding-left:0") {{$t('Payment type')}}
              th(class="text-left" width="110") {{$t('Sum')}}
          tbody
            template(v-for="(item, key) in amountPayments")
              tr(:key="key + 'payment-method'")
                td(height="20px" align="center" style="padding-left:0")
                    e-svg-icon(style="margin-top:5px; cursor:pointer" v-if="item.dynamic && !item.loading" @click.native="deletePaymentMethod(item)" ) delete
                    e-progress-circular(size="sm" v-if="item.loading")
                td(style="padding-left:0")
                  | {{item.label}}
                td
                  v-text-field(v-model="item.amount" @blur="formatValue(item)" @keypress="floatKeyPress" class="money-input" hide-details outlined)
                td(height="20px" align="center" style="padding-left:0")
            tr(v-if="paymentsLoading")
              td(colspan="4")
                e-progress-linear(size="sm")
            tr(v-for="(payment, index) in newPayments" :key="index")
              td(height="20px" align="center" style="padding-left:0")
                e-svg-icon(style="margin-top:5px; cursor:pointer" v-if="index !== 0" @click="deleteNewPaymentInput(index)") delete
              td(style="padding-left:0")
                v-text-field(v-model="payment.label" :label="$t('Enter own payment type')" hide-details outlined)
              td(class="relative")
                v-text-field(v-model="payment.amount" @blur="formatValue(newPayments[index])" @keypress="floatKeyPress" class="money-input" hide-details outlined)
              td(height="20px" align="center" style="padding-left:0")
                v-btn(icon class="m-block-receipt-sale-mixed-payment-types__add-new-payment-btn" @click="addNewPaymentInput" v-if="index === newPayments.length - 1")
                  e-svg-icon plus
    v-col(cols="auto" class="my-5")
      v-btn(color="primary" :loading="loading" class="main-button" @click="submitPaymentTypes" depressed)
        | {{$t('Continue')}}
</template>

<script>
import currencyFormat from '~/mixins/filters/currencyFormat'
import ReceiptPaymentMethods from '~/modules/receipt/models/ReceiptPaymentMethods'
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import routes from '~/const/routes'
import EProgressCircular from '~/components/elements/progress/e-progress-circular'
import EProgressLinear from '~/components/elements/progress/e-progress-linear'
import responsive from '~/mixins/pages/responsive'

export default {
  components: { EProgressLinear, EProgressCircular, ESvgIcon },
  mixins: [currencyFormat, responsive],
  props: {
    closeModal: {
      type: Function,
      default: null
    },
    payments: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      loading: false,
      paymentsLoading: false,
      staticPayments: [
        {
          type: 'CASH',
          label: 'Готівка',
          amount: null,
          id: 'cash'
        },
        {
          type: 'CARD',
          label: 'Картка',
          amount: null,
          id: 'card'
        },
        {
          type: 'CASHLESS',
          label: 'Бонуси',
          amount: null,
          id: 'bonus'
        }
      ],
      newPayments: [
        {
          type: 'CASHLESS',
          label: null,
          amount: null,
          id: null
        }
      ],
      amountPayments: []
    }
  },
  computed: {
    mergedPayments () {
      const dynamic = ReceiptPaymentMethods.query().all().map((item) => {
        return {
          type: item.paymentType,
          label: item.label,
          id: item.id,
          amount: null,
          dynamic: true,
          loading: false
        }
      })
      return this.staticPayments.concat(dynamic)
    }
  },
  async created () {
    if (!this.$Organization) {
      return
    }
    this.paymentsLoading = true
    await ReceiptPaymentMethods.api().all()
    this.paymentsLoading = false
    this.calculatePayments()
    this.setPaymentsAmount()
  },
  methods: {
    async deletePaymentMethod (item) {
      try {
        item.loading = true
        await ReceiptPaymentMethods.api().delete(routes.receiptpaymentmethod.concrete(item.id), { delete: item.id })
        this.calculatePayments()
      } catch (e) {
        this.$handlers.error(e, this)
      }
    },
    calculatePayments () {
      this.$set(this, 'amountPayments', this.mergedPayments)
      // TODO set external payments
    },
    setPaymentsAmount () {
      this.payments.forEach((item) => {
        const element = this.amountPayments.find(el => el.id === item.id)
        element.amount = item.amount
      })
    },
    formatValue (item) {
      item.amount = this.moneyUahFormatter(item.amount)
    },
    addNewPaymentInput () {
      const copy = JSON.parse(JSON.stringify(this.newPayments))
      this.newPayments = [...copy, {
        type: 'CASHLESS',
        label: null,
        amount: null,
        id: null
      }]
    },
    deleteNewPaymentInput (index) {
      const copy = JSON.parse(JSON.stringify(this.newPayments))
      this.newPayments = this._.remove(copy, (v, i) => i !== index)
    },
    async submitPaymentTypes () {
      await this._.forEach(this.newPayments, async (payment) => {
        const newId = await this.addNewPaymentMethod(payment)
        if (newId) {
          payment.id = newId.id
        }
      })

      const merged = this.amountPayments.concat(this.newPayments)
      this.closeModal(merged.filter(item => item.amount))
    },
    async addNewPaymentMethod (payment) {
      if (!payment.label || !this.$Organization) {
        return
      }
      try {
        this.loading = true
        const response = await ReceiptPaymentMethods.api().create({
          label: payment.label
        })
        return this._.get(response, 'entities.receiptpaymentmethod[0]')
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }

}
</script>

<style scoped lang="scss">
.m-block-receipt-sale-mixed-payment-types {
  td, th {
    padding: 0 8px;
    font-size: 0.75rem !important;
    color: #000 !important;

    @media (min-width: map-get($breakpoints, 'sm')) {
      font-size: 0.875rem !important;
    }
  }

  tr {
    &:hover {
      background-color: transparent !important;
    }

    ::v-deep.v-input__control {
      .v-text-field__details {
        padding: 0;

        .v-messages__message {
          font-size: 9px;
        }
      }

      .v-input__slot {
        min-height: 32px !important;

        fieldset {
          border-color: #e0e0e0;
        }

        .v-input__append-inner {
          margin-top: 5px !important;
        }

        .v-text-field__slot {
          label {
            font-size: 10px !important;
            top: 7px;

            @media (min-width: map-get($breakpoints, 'sm')) {
              font-size: 13px !important;
            }
          }

          input {
            font-size: 13px;
            padding: 0;
            line-height: 16px;
          }
        }
      }
    }

    .money-input {
      ::v-deep.v-text-field__slot {
        input {
          text-align: right;
        }
      }
    }
  }

  tr, th, td {
    border-bottom: 0 !important;
  }

  &__add-new-payment-btn {
    height: 24px;
    width: 24px;
    background: linear-gradient(247.21deg, #8ce2b0 8.73%, #04aed5 90.64%);

    ::v-deep {
      .svg-icon.md {
        max-height: 16px;
        max-width: 11px;
      }
    }
  }
}

</style>
